/**
 * @flow
 * @relayHash eee044e86f62d3928b65dc66c6e3c734
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ResendTwoFactorCodeInput = {|
  twoFactorToken: string
|};
export type ResendTwoFactorCodeMutationVariables = {|
  input: ResendTwoFactorCodeInput
|};
export type ResendTwoFactorCodeMutationResponse = {|
  +resendTwoFactorCode: {|
    +success: boolean
  |}
|};
export type ResendTwoFactorCodeMutation = {|
  variables: ResendTwoFactorCodeMutationVariables,
  response: ResendTwoFactorCodeMutationResponse,
|};
*/


/*
mutation ResendTwoFactorCodeMutation(
  $input: ResendTwoFactorCodeInput!
) {
  resendTwoFactorCode(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ResendTwoFactorCodeInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "resendTwoFactorCode",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResendTwoFactorCodePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ResendTwoFactorCodeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ResendTwoFactorCodeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ResendTwoFactorCodeMutation",
    "id": null,
    "text": "mutation ResendTwoFactorCodeMutation(\n  $input: ResendTwoFactorCodeInput!\n) {\n  resendTwoFactorCode(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '109e11f93d836d520cc390edbb36d36a';
module.exports = node;
